import React from "react";

import { useQuery } from "react-admin";

import { Box, Link } from "@material-ui/core";

const PrequalRedirectionLink = ({ customerFile }) => {
  const url = `${process.env.REACT_APP_MURFY_TECH_URL || ""}/prequalification`;

  const { data: prequals } = useQuery({
    type: "getMany",
    resource: "fault-forecast",
    payload: {
      ids: customerFile.products.map((product) => {
        return product.id;
      }),
    },
  });
  return (
    <Box color="blue" display={"inline-grid"}>
      {prequals &&
        prequals.map((prequal) => {
          const product = customerFile.products.find((product) => product.id === prequal.product);
          const productType = product && product.identification && product.identification.product_type;
          const productBrand = product && product.identification && product.identification.brand;
          const productModelReference = product && product.identification && product.identification.model_reference;
          return (
            <Link
              component="button"
              variant="body1"
              color="inherit"
              onClick={() => {
                window.open(`${url}/${prequal.id}/`, "_blank");
              }}
            >
              {`+ Faire une préqualification ${productType} ${productBrand} ${productModelReference || ""} `}
            </Link>
          );
        })}
    </Box>
  );
};

export default PrequalRedirectionLink;
